/* CYGNUSS 12/10/2026: faixa "Baixar" do app no topo da home (pedido do Guifa).
   Android com Chrome: abre a janela de instalar do proprio Chrome. iPhone e navegadores sem essa janela: mostra os 2 toques.
   O X esconde a faixa ate a proxima visita; depois de instalar, a faixa some. */
(function () {
  var faixa = document.querySelector('[data-cyg-app-faixa]');
  if (!faixa) return;
  var folha = document.querySelector('[data-cyg-app-folha]');
  var pedido = null;
  window.addEventListener('beforeinstallprompt', function (e) { e.preventDefault(); pedido = e; });
  window.addEventListener('appinstalled', esconde);
  function esconde() { document.documentElement.classList.remove('cyg-convite'); }

  faixa.querySelector('[data-cyg-app-fecha]').addEventListener('click', function () {
    try { sessionStorage.setItem('cyg-convite-fechado', '1'); } catch (e) {}
    esconde();
  });

  faixa.querySelector('[data-cyg-app-baixar]').addEventListener('click', function () {
    if (pedido) {
      var p = pedido; pedido = null;
      p.prompt();
      if (p.userChoice) p.userChoice.then(function (r) { if (r && r.outcome === 'accepted') esconde(); }).catch(function () {});
      return;
    }
    abreFolha();
  });

  function abreFolha() {
    if (!folha || typeof folha.showModal !== 'function') return;
    var ua = navigator.userAgent;
    var ios = /iPhone|iPad|iPod/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    var p1 = folha.querySelector('[data-cyg-app-passo1]');
    var p2 = folha.querySelector('[data-cyg-app-passo2]');
    var s1 = folha.querySelector('[data-cyg-app-sym1]');
    if (ios) {
      /* no Safari 26 o Compartilhar fica dentro do botao ••• */
      var v = /Version\/(\d+)/.exec(ua);
      if (v && +v[1] >= 26) p1.innerHTML = 'Toque em <b>•••</b> e em <b>Compartilhar</b>';
    } else {
      p1.innerHTML = 'Toque no menu <b>⋮</b> do navegador';
      p2.innerHTML = '<b>Instalar app</b> ou Adicionar à tela inicial';
      s1.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="5" r="1.6"/><circle cx="12" cy="12" r="1.6"/><circle cx="12" cy="19" r="1.6"/></svg>';
    }
    folha.showModal();
  }

  if (folha) {
    folha.querySelector('[data-cyg-app-ok]').addEventListener('click', function () { folha.close(); });
    /* toque fora da janelinha fecha */
    folha.addEventListener('click', function (e) {
      if (e.target !== folha) return;
      var r = folha.getBoundingClientRect();
      if (e.clientY < r.top || e.clientY > r.bottom || e.clientX < r.left || e.clientX > r.right) folha.close();
    });
  }
})();
